<script setup lang="ts">
import { ref, onMounted } from 'vue'
import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import walletService from '@/services/walletService'
import { formatAmount } from '@/utils/formatters'

const balance = ref<number | null>(null)

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/wallet',
    icon: '/public/icons/icon-dashboard.svg',
    label: 'Dashboard',
    exact: true,
    initialSidebarOpen: false
  },
  {
    to: '/front/wallet/utilisation',
    icon: '/public/icons/icon-utilisation.svg',
    label: 'Utilisation',
    initialSidebarOpen: true
  }
]

onMounted(async () => {
  try {
    const res = await walletService.getBalance()
    if (res.data) balance.value = res.data.balance || 0
  } catch (e) {
    // silencieux
  }
})
</script>

<template>
  <SectionSidebar :menu-items="menuItems">
    <template #widget>
      <div class="sidebar-top px-3" v-if="balance !== null">
        <div class="widget s20 text-black p-4 rounded-40 shadow-200 mb-6 px-7 pt-7 pb-6">
          <div class="flex align-items-center gap-4 mb-3">
            <img src="/public/icons/icon-wallet.svg" class="size-base icon-neutral" alt="" />
            <h4 class="secondary-font">Wallet</h4>
          </div>
          <h2 class="secondary-font text-primary-color">
            {{ formatAmount(balance) }} F
          </h2>
        </div>
      </div>
    </template>
  </SectionSidebar>

  <section class="app-section">
    <div class="page-space-25" />
    <router-view />
  </section>
</template>
